export const mutations = {
  setSectionsOrder(state, payload) {
    state.sectionsOrder = payload;
  },
};
